import cogoToast from 'cogo-toast';
import { takeLatest, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import {
  SUBMIT_MANUAL_BOOKING_APPROVAL,
  SUBMIT_MANUAL_BOOKING_APPROVAL_SUCCESS,
  SUBMIT_MANUAL_BOOKING_APPROVAL_ERROR,
} from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* submitManualBookingApproval({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const isBookingModification = payload.issueType === 'booking_modification';

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/utility-request/${isBookingModification ? 'booking-modification' : 'manual-booking'}/send-for-approval`,
      method: 'POST',
      data: {
        draft_id: payload.draftId,
        priority: payload.priority,
        ...(!isBookingModification && { reason_for_change: payload.reasonForChange }),
      },
      headers: filteredHeaders,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success('Request submitted for approval');
      yield put({ type: SUBMIT_MANUAL_BOOKING_APPROVAL_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message || 'Failed to submit request');
      yield put({ type: SUBMIT_MANUAL_BOOKING_APPROVAL_ERROR, payload: response?.response?.data?.message });
    }
  } catch (error) {
    cogoToast.error('Failed to submit request');
    yield put({ type: SUBMIT_MANUAL_BOOKING_APPROVAL_ERROR, payload: error });
  }
}

export function* watchSubmitManualBookingApproval() {
  yield takeLatest(SUBMIT_MANUAL_BOOKING_APPROVAL, submitManualBookingApproval);
}

function* submitManualBookingApprovalSaga() {
  yield all([fork(watchSubmitManualBookingApproval)]);
}

export default submitManualBookingApprovalSaga;